import { createContext, useContext } from "react";

interface NavigationContextType {
  navigateTo: (slug: string) => void;
}

export const NavigationContext = createContext<NavigationContextType>({
  navigateTo: () => {},
});

export const useNavigation = () => useContext(NavigationContext);
